// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"6742e357","787":"a7f8fa40"}[chunkId] + ".chunk.js";
};